import React, { FC } from 'react';
import * as styles from './NoWordWrap.module.scss';

const NoWordWrap: FC = ({ children }) => {
  return <span className={styles.noWordWrap}>{children}</span>;
};

export default NoWordWrap;
